export default "__VITE_ASSET__CikTksYN__"